module.exports = __webpack_public_path__ + "img/strikethrough.bace8159.svg";